import { ThemeProvider } from "@emotion/react";
import { CssBaseline, Grid, useMediaQuery } from "@mui/material";
import { skipToken } from "@reduxjs/toolkit/query";
import { useEffect } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { useNavigate } from "react-router-dom";
import "./ChatStyles.css";
import { ToastProvider } from "./Context/ToastProvider";
import { useAdmin } from "./Hooks/useAdmin";
import { useSubscription } from "./Hooks/useSubscription";
import { useUser } from "./Hooks/useUser";
import { useGetChatUsersQuery } from "./Redux/api/chatApi";
import { useGetMessagesQuery } from "./Redux/api/messageApi";
import { useGetNotificationsQuery } from "./Redux/api/notificationApi";
import { useGetDefaultPaymentMethodQuery } from "./Redux/api/stripeApi";
import { setShowDeactivatedModal } from "./Redux/slices/GlobalModalSlice";
import { setChatUsers, setDefaultPaymentMethod, setShowBackButton } from "./Redux/slices/GlobalSlice";
import { setHasNotifications, setNotficationCount, setRead } from "./Redux/slices/NotificationSlice";
import { useAppDispatch, useAppSelector } from "./Redux/store";
import { KaziRoutes } from "./Routes/KaziRoutes";
import { AddPaymentMethod } from "./Shared Components/AddPaymentMethod";
import { DeactivatedModal } from "./Shared Components/DeactivatedModal";
import FallbackPage from "./Shared Components/FallbackPage";
import { Footer } from "./Shared Components/Footer";
import { CreateJobPostingModal } from "./Shared Components/Job Creation/CreateJobPostingModal";
import { HorizontalNavbar } from "./Shared Components/Navigation/HorizontalNavbar";
import { VerticalNavbar } from "./Shared Components/Navigation/Vertical/VerticalNavbar";
import { Searchbar } from "./Shared Components/Searchbar";
import { getTheme } from "./Theme";
import { UnverifiedModal } from "./Shared Components/UnverifiedModal";
import { AppSettings } from "./Utils/Settings";
import { useAWSWebsocket } from "./Hooks/useAWSWebsocket";
import { useInitializeApp } from "./Hooks/useInitializeApp";

console.log("Environment: ", AppSettings.NodeEnvironment)
const App = () => {
  /* ******************** Hooks ******************** */
  useInitializeApp();
  /* ******************** Variables ******************** */
  const globalSlice = useAppSelector(state => state.Global);
  const clientSecret = useAppSelector( state => state.Global.clientSecret);
  const dispatch = useAppDispatch();
  const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)');
  const theme = getTheme(globalSlice.themeMode);
  const match = useMediaQuery(theme.breakpoints.down('lg'));
  const { isAdmin } = useAdmin();
  //TODO: Make this a global variable
  const hideSearchbar = isAdmin || window.location.pathname === '/messages' || window.location.pathname === '/post-creation';
  /* ******************** Functions ******************** */
  const Fallback = ({error}: any) =>{
    return (
      <FallbackPage {...{error}} />
    )
  }
  const setDeactivatedOpen = (open: boolean) => {
   return dispatch(setShowDeactivatedModal(open)); 
  }
  /* ******************** Effects ******************** */
  useEffect(()=>{
    if (globalSlice.isLoggedIn && !globalSlice.userId) console.log("No user Id")
  }, [globalSlice.userId])
  // useEffect(() => {
  //   if (prefersDarkMode) dispatch(setThemeMode('dark'))
  // }, [prefersDarkMode])
  /* ******************** JSX ******************** */
 return (
  <ThemeProvider theme={theme}>
    <ErrorBoundary FallbackComponent={Fallback}>
      <CssBaseline />
      <ToastProvider>
        <Grid container  height={"100%"} display={"flex"} flexDirection={(!globalSlice.isLoggedIn || match) ?"column":"row"} flexWrap={"nowrap"}>
          {
            !globalSlice.isLoggedIn 
            ? 
            <>
                <HorizontalNavbar />
                <Grid item xs>
                    <KaziRoutes />
                </Grid>            
                <Footer />
              </>              
            : 
              <>          
                <VerticalNavbar />
                <Grid item xs overflow={"auto"} >
                    {!hideSearchbar && <Searchbar />}
                    <KaziRoutes />
                </Grid>
              </>
          }
        </Grid>
        <CreateJobPostingModal />
        {clientSecret && <AddPaymentMethod />}
        <DeactivatedModal />
        <UnverifiedModal />
      </ToastProvider>
    </ErrorBoundary>
  </ThemeProvider>
 );
};
 export default App;
